<template>
    <div>
        <vx-collapse accordion type="margin" class="p-0" ref="comissoes" @change="detalharComissao">
            <vx-collapse-item v-for="(com, index) in comissoes" class="comissoes-bg rounded-lg" :class="{'mt-0': !index}" :key="index">
                <div slot="header">
                    <div class="flex space-between">
                        <div class="vx-col px-3 sm:w-1/2">
                            <h4 class="text-primary">{{ formatDate(com.periodo) }}</h4>
                        </div>
                        <div class="vx-col px-3 sm:w-1/2 text-right">
                            <b class="text-success">{{  com.valor }}</b>
                        </div>
                    </div>
                </div>
                <div>
                    <vx-collapse accordion>
                        <!-- Tabela com a lista de registro creditados -->
                        <vx-collapse-item v-if="com.detalhes && com.detalhes.length">
                            <div slot="header">
                                <div class="flex space-between">
                                    <div class="vx-col px-3 sm:w-1/2">
                                        Recebidos na empresa
                                    </div>
                                    <div class="vx-col px-3 sm:w-1/2 text-right">
                                        <b class="text-primary">{{ computeTotalItem(com.percentuais) }}</b>
                                    </div>
                                </div>
                            </div>
                            <div class="comissoes-table m-5">
                                <vs-table :data="com.percentuais" class="mt-5 mb-5">

                                    <template slot="thead">
                                        <vs-th >Quantidade</vs-th>
                                        <vs-th class="th-float" width="155px"><span class="text-right" v-tooltip.top="'Empresa'">Recebido (R$)</span></vs-th>
                                        <vs-th class="th-float" width="135px"><span class="text-right">Comissão (%)</span></vs-th>
                                        <vs-th class="th-float" width="135px"><span class="text-right">Taxas (R$)</span></vs-th>
                                        <vs-th class="th-float" width="150px"><span class="text-right" >Comissão (R$)</span></vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="data[indextr]" :key="indextr" v-for="(tr, indextr) in data" >
                                            <vs-td>
                                                {{data[indextr].qtde_mov}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].total_recebido}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].percentual}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].taxas}}
                                            </vs-td>
                                            <vs-td class="text-right text-success">
                                                <span v-if="data[indextr].tooltip" v-tooltip.top="data[indextr].tooltip">
                                                    {{data[indextr].total}}
                                                </span>
                                                <span v-else>
                                                    {{data[indextr].total}}
                                                </span>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                                <vs-table :data="com.detalhes">

                                    <template slot="thead">
                                        <vs-th sort-key="data_credito">Data</vs-th>
                                        <vs-th sort-key="id_cliente">Id</vs-th>
                                        <vs-th sort-key="nome_cliente">Nome</vs-th>
                                        <vs-th sort-key="plano_conta_nome">Tipo</vs-th>
                                        <vs-th sort-key="parcela_valor" class="th-float" width="155px"><span class="text-right">Parcela (R$)</span></vs-th>
                                        <vs-th sort-key="valor_recebido" class="th-float" width="155px"><span class="text-right" v-tooltip.top="'Empresa'">Recebido (R$)</span></vs-th>
                                        <vs-th sort-key="percentual_aplicado" class="th-float" width="135px"><span class="text-right">Comissão (%)</span></vs-th>
                                        <vs-th sort-key="taxa" class="th-float" width="135px"><span class="text-right">Taxas (R$)</span></vs-th>
                                        <vs-th sort-key="valor" class="th-float" width="150px"><span class="text-right">Comissão (R$)</span></vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="data[indextr]" :key="indextr" v-for="(tr, indextr) in data" :class="{ 'text-blue' : data[indextr].percentual_aplicado === '100,00' }" >
                                            <vs-td :data="data[indextr].data_credito">
                                                {{data[indextr].data_credito}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].id_cliente">
                                                {{data[indextr].id_cliente}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].nome_cliente">
                                                {{data[indextr].nome_cliente}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].plano_conta_nome">
                                                {{data[indextr].plano_conta_nome}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].parcela_valor}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].valor_recebido}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].percentual_aplicado}}
                                            </vs-td>
                                            <vs-td class="text-right" :class="{'text-danger': data[indextr].taxa !== '0,00'}">
                                                {{data[indextr].taxa}}
                                            </vs-td>
                                            <vs-td class="text-right text-success">
                                                <span v-if="data[indextr].tooltip" v-tooltip.top="data[indextr].tooltip" class="detail">
                                                    {{data[indextr].valor}}
                                                </span>
                                                <span v-else>
                                                    {{data[indextr].valor}}
                                                </span>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </vx-collapse-item> 
                        <!-- Tabela com a lista de registro recebidos em mãos-->
                        <vx-collapse-item v-if="com.detalhes_em_maos && com.detalhes_em_maos.length">
                            <div slot="header">
                                <div class="flex space-between">
                                    <div class="vx-col px-3 sm:w-1/2">
                                        Recebidos em mãos
                                    </div>
                                    <div class="vx-col px-3 sm:w-1/2 text-right">
                                        <b class="text-primary">{{ computeTotalItem(com.percentuais_em_maos) }}</b>
                                    </div>
                                </div>
                            </div>
                            <div class="comissoes-table m-5">
                                <vs-table :data="com.percentuais_em_maos" class="mt-5 mb-5">

                                    <template slot="thead">
                                        <vs-th >Quantidade</vs-th>
                                        <vs-th class="th-float" width="155px"><span class="text-right" v-tooltip.top="'Empresa'">Recebido (R$)</span></vs-th>
                                        <vs-th class="th-float" width="135px"><span class="text-right">Comissão (%)</span></vs-th>
                                        <vs-th class="th-float" width="135px"><span class="text-right">Taxas (R$)</span></vs-th>
                                        <vs-th class="th-float" width="150px"><span class="text-right" >Comissão (R$)</span></vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="data[indextr]" :key="indextr" v-for="(tr, indextr) in data" >
                                            <vs-td>
                                                {{data[indextr].qtde_mov}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].total_recebido}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].percentual}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].taxas}}
                                            </vs-td>
                                            <vs-td class="text-right text-success">
                                                <span v-if="data[indextr].tooltip" v-tooltip.top="data[indextr].tooltip">
                                                    {{data[indextr].total}}
                                                </span>
                                                <span v-else>
                                                    {{data[indextr].total}}
                                                </span>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                                <vs-table :data="com.detalhes_em_maos">

                                    <template slot="thead">
                                        <vs-th sort-key="data_credito">Data</vs-th>
                                        <vs-th sort-key="id_cliente">Id</vs-th>
                                        <vs-th sort-key="nome_cliente">Nome</vs-th>
                                        <vs-th sort-key="plano_conta_nome">Tipo</vs-th>
                                        <vs-th sort-key="parcela_valor" class="th-float" width="155px"><span class="text-right">Parcela (R$)</span></vs-th>
                                        <vs-th sort-key="valor_recebido" class="th-float" width="155px" v-tooltip.top="'Empresa'"><span class="text-right">Recebido (R$)</span></vs-th>
                                        <vs-th sort-key="percentual_aplicado" class="th-float" width="135px"><span class="text-right">Comissão (%)</span></vs-th>
                                        <vs-th sort-key="taxa" class="th-float" width="135px"><span class="text-right">Taxas (R$)</span></vs-th>
                                        <vs-th sort-key="valor" class="th-float" width="150px"><span class="text-right">Comissão (R$)</span></vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="data[indextr]" :key="indextr" v-for="(tr, indextr) in data" :class="{ 'text-blue' : data[indextr].percentual_aplicado === '100,00' }" >
                                            <vs-td :data="data[indextr].data_credito">
                                                {{data[indextr].data_credito}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].id_cliente">
                                                {{data[indextr].id_cliente}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].nome_cliente">
                                                {{data[indextr].nome_cliente}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].plano_conta_nome">
                                                {{data[indextr].plano_conta_nome}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].parcela_valor}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].valor_recebido}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].percentual_aplicado}}
                                            </vs-td>
                                            <vs-td class="text-right" :class="{'text-danger': data[indextr].taxa !== '0,00'}">
                                                {{data[indextr].taxa}}
                                            </vs-td>
                                            <vs-td class="text-right text-success">
                                                <span v-if="data[indextr].tooltip" v-tooltip.top="data[indextr].tooltip" class="detail">
                                                    {{data[indextr].valor}}
                                                </span>
                                                <span v-else>
                                                    {{data[indextr].valor}}
                                                </span>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </vx-collapse-item>
                        <!-- Tabela com a lista de registro a ser creditados no mes seguinte-->
                        <vx-collapse-item v-if="com.detalhes_creditado && com.detalhes_creditado.length">
                            <div slot="header">
                                <div class="flex space-between">
                                    <div class="vx-col px-3 sm:w-1/2">
                                        A creditar
                                    </div>
                                    <div class="vx-col px-3 sm:w-1/2 text-right">
                                        <b class="text-warning">{{ computeTotalItem(com.percentuais_creditado) }}</b>
                                    </div>
                                </div>
                            </div>
                            <div class="comissoes-table m-5">
                                <vs-table :data="com.percentuais_creditado" class="mt-5 mb-5">

                                    <template slot="thead">
                                        <vs-th >Quantidade</vs-th>
                                        <vs-th class="th-float" width="155px"><span class="text-right" v-tooltip.top="'Empresa'">A creditar (R$)</span></vs-th>
                                        <vs-th class="th-float" width="135px"><span class="text-right">Comissão (%)</span></vs-th>
                                        <vs-th class="th-float" width="135px"><span class="text-right">Taxas (R$)</span></vs-th>
                                        <vs-th class="th-float" width="150px"><span class="text-right" >Comissão (R$)</span></vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="data[indextr]" :key="indextr" v-for="(tr, indextr) in data" >
                                            <vs-td>
                                                {{data[indextr].qtde_mov}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].total_recebido}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].percentual}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].taxas}}
                                            </vs-td>
                                            <vs-td class="text-right text-success">
                                                <span v-if="data[indextr].tooltip" v-tooltip.top="data[indextr].tooltip">
                                                    {{data[indextr].total}}
                                                </span>
                                                <span v-else>
                                                    {{data[indextr].total}}
                                                </span>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                                <vs-table :data="com.detalhes_creditado">

                                    <template slot="thead">
                                        <vs-th sort-key="data_credito">Data</vs-th>
                                        <vs-th sort-key="id_cliente">Id</vs-th>
                                        <vs-th sort-key="nome_cliente">Nome</vs-th>
                                        <vs-th sort-key="plano_conta_nome">Tipo</vs-th>
                                        <vs-th sort-key="parcela_valor" class="th-float" width="155px"><span class="text-right">Parcela (R$)</span></vs-th>
                                        <vs-th sort-key="valor_recebido" class="th-float" width="155px"><span class="text-right" v-tooltip.top="'Empresa'">A creditar (R$)</span></vs-th>
                                        <vs-th sort-key="percentual_aplicado" class="th-float" width="135px"><span class="text-right">Comissão (%)</span></vs-th>
                                        <vs-th sort-key="taxa" class="th-float" width="135px"><span class="text-right">Taxas (R$)</span></vs-th>
                                        <vs-th sort-key="valor" class="th-float" width="150px"><span class="text-right">Comissão (R$)</span></vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="data[indextr]" :key="indextr" v-for="(tr, indextr) in data" :class="{ 'text-blue' : data[indextr].percentual_aplicado === '100,00' }" >
                                            <vs-td :data="data[indextr].data_credito">
                                                {{data[indextr].data_credito}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].id_cliente">
                                                {{data[indextr].id_cliente}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].nome_cliente">
                                                {{data[indextr].nome_cliente}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].plano_conta_nome">
                                                {{data[indextr].plano_conta_nome}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].parcela_valor}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].valor_recebido}}
                                            </vs-td>
                                            <vs-td class="text-right">
                                                {{data[indextr].percentual_aplicado}}
                                            </vs-td>
                                            <vs-td class="text-right" :class="{'text-danger': data[indextr].taxa !== '0,00'}">
                                                {{data[indextr].taxa}}
                                            </vs-td>
                                            <vs-td class="text-right text-success">
                                                <span v-if="data[indextr].tooltip" v-tooltip.top="data[indextr].tooltip" class="detail">
                                                    {{data[indextr].valor}}
                                                </span>
                                                <span v-else>
                                                    {{data[indextr].valor}}
                                                </span>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </vx-collapse-item>
                    </vx-collapse>
                </div>
            </vx-collapse-item>
        </vx-collapse>
        <vx-card v-if="comissoes.length === 0 && !loading">
            <div slot="no-body">
                <div class="vx-row text-center">
                    <div class="vx-col w-full flex flex-col justify-between mb-4">
                        <h1 class="ml-6 mt-6 text-2xl text-grey">Não foram encontradas comissões para o filtro aplicado</h1>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import { moment} from "../helpers/moment";
    import accounting from 'accounting';
    import {mapActions, mapGetters} from 'vuex';
    import _ from 'lodash';
    const {toDecimal} = require('../helpers/utils')

    export default {
        name: "Comissoes",
        data() {
            return {
                panel:'1',
                loading: true,
                comissoes: [],
            }
        },
        computed: {
            ...mapGetters(['daterange', 'relatorioComissoes', 'idUser'])
        },
        methods: {
            ...mapActions(['updateRelatorioComissoes']),
            async init() {
                const {startDate, endDate, idUser, data} = this.relatorioComissoes;
                if (moment(this.daterange.startDate).isSame(startDate, 'day') &&
                    moment(this.daterange.endDate).isSame(endDate, 'day') && this.idUser === idUser && data.length) {
                    this.comissoes = [...data]
                } else {
                    await this.$store.dispatch('updateDateRange', {
                        startDate: moment().subtract(11, 'months').startOf('month'),
                        endDate: moment().endOf('month'),
                    });
                }
            },
            async getComissoes() {
                this.comissoes = [];
                const data_inicial = moment(this.daterange.startDate).format("YYYY-MM-DD");
                const data_final = moment(this.daterange.endDate).format("YYYY-MM-DD");

                const { data } = await this.$axios.get('comissoes/relatorio', { params: {data_inicial, data_final} });
                this.comissoes = Object.values(data).map(comissao => {
                    const [ano, mes] = comissao.ano_mes.split('_');
                    comissao.periodo = `${mes}/${ano}`;
                    comissao.valor = accounting.formatNumber(comissao.total_comissao, 2, ".", ",");
                    comissao.detalhes = [];
                    comissao.percentuais = [];
                    return comissao;
                }).reverse();
                this.loading = false;

                await this.updateStore();
            },
            detalharComissao() {
                const index = this.$refs.comissoes.$children.findIndex(comissao => comissao.maxHeight !== "0px");

                if (index > -1) {                 
                    this.detalhar(index);
                }
            },
            async detalhar(index) {
                
                const [ano, mes] = this.comissoes[index].ano_mes.split('_');

                const data_inicial = moment(this.daterange.startDate).format("YYYY-MM-DD");
                const data_final = moment(this.daterange.endDate).format("YYYY-MM-DD");

                const { data } = await this.$axios.get(`comissoes/relatorio/detalhar/${ ano }/${ mes }`, { params: {data_inicial, data_final} });
                
                const percentuais = Object.values(data.recebido.reduce((carry, dados) => {
                    const key = dados.percentual_aplicado;
                    if (carry[key]) {
                        carry[key][`qtde_mov`]++;
                        carry[key][`total_recebido`] += parseFloat(dados.valor_recebido || 0);
                        carry[key][`taxas`] += parseFloat(dados.taxa);
                        carry[key][`total_comissao`] += parseFloat(dados.lancamento_valor);
                    } else {
                        carry[key] = {
                            percentual: parseFloat(dados.percentual_aplicado),
                            qtde_mov: 1,
                            total_recebido: parseFloat(dados.valor_recebido || 0),
                            taxas: parseFloat(dados.taxa),
                            total_comissao: parseFloat(dados.lancamento_valor)
                        };
                    }
                    return carry;
                }, {})).map(perc => {
                    perc.tooltip = perc.taxas ? `${perc.percentual}% (R$ ${ accounting.formatNumber(parseFloat(perc.total_recebido), 2, ".", ",") } - R$ ${ accounting.formatNumber(perc.taxas, 2, ".", ",") })` : null
                    perc.total = accounting.formatNumber(perc.total_comissao, 2, ".", ",");
                    perc.total_recebido = accounting.formatNumber(perc.total_recebido, 2, ".", ",");
                    perc.percentual = accounting.formatNumber(perc.percentual, 2, ".", ",");
                    perc.taxas = accounting.formatNumber(perc.taxas, 2, ".", ",");
                    perc.total_comissao = accounting.formatNumber(perc.total_comissao, 2, ".", ",");
                    return perc;
                })
                const detalhes = _.orderBy(data.recebido.slice(0).map(comissao => {
                    comissao.tooltip = comissao.taxa ? `${accounting.formatNumber(comissao.percentual_aplicado, 2, ".", ",")}% (R$ ${ accounting.formatNumber(comissao.parcela_valor, 2, ".", ",") } - R$ ${ accounting.formatNumber(comissao.taxa, 2, ".", ",") })` : null
                    comissao.valor = accounting.formatNumber(comissao.lancamento_valor, 2, ".", ",");
                    comissao.percentual_aplicado = accounting.formatNumber(comissao.percentual_aplicado, 2, ".", ",");
                    comissao.data_credito = moment(comissao.data_credito).format('DD/MM/YYYY');
                    comissao.parcela_valor = accounting.formatNumber(comissao.parcela_valor, 2, ".", ",");
                    comissao.valor_recebido = accounting.formatNumber(comissao.valor_recebido, 2, ".", ",");
                    comissao.taxa = accounting.formatNumber(comissao.taxa, 2, ".", ",");
                    return comissao;
                }), ['data_credito'], ['desc'])

                const percentuais_em_maos = Object.values(data.recebido_em_maos.reduce((carry, dados) => {
                    const key = dados.percentual_aplicado;
                    if (carry[key]) {
                        carry[key][`qtde_mov`]++;
                        carry[key][`total_recebido`] += parseFloat(dados.valor_recebido || 0);
                        carry[key][`taxas`] += parseFloat(dados.taxa);
                        carry[key][`total_comissao`] += parseFloat(dados.lancamento_valor);
                    } else {
                        carry[key] = {
                            percentual: parseFloat(dados.percentual_aplicado),
                            qtde_mov: 1,
                            total_recebido: parseFloat(dados.valor_recebido || 0),
                            taxas: parseFloat(dados.taxa),
                            total_comissao: parseFloat(dados.lancamento_valor)
                        };
                    }
                    return carry;
                }, {})).map(perc => {
                    perc.tooltip = perc.taxas ? `${perc.percentual}% (R$ ${ accounting.formatNumber(parseFloat(perc.total_recebido), 2, ".", ",") } - R$ ${ accounting.formatNumber(perc.taxas, 2, ".", ",") })` : null
                    perc.total = accounting.formatNumber(perc.total_comissao, 2, ".", ",");
                    perc.total_recebido = accounting.formatNumber(perc.total_recebido, 2, ".", ",");
                    perc.percentual = accounting.formatNumber(perc.percentual, 2, ".", ",");
                    perc.taxas = accounting.formatNumber(perc.taxas, 2, ".", ",");
                    perc.total_comissao = accounting.formatNumber(perc.total_comissao, 2, ".", ",");
                    return perc;
                })
                const detalhes_em_maos = _.orderBy(data.recebido_em_maos.slice(0).map(comissao => {
                    comissao.tooltip = comissao.taxa ? `${accounting.formatNumber(comissao.percentual_aplicado, 2, ".", ",")}% (R$ ${ accounting.formatNumber(comissao.parcela_valor, 2, ".", ",") } - R$ ${ accounting.formatNumber(comissao.taxa, 2, ".", ",") })` : null
                    comissao.valor = accounting.formatNumber(comissao.lancamento_valor, 2, ".", ",");
                    comissao.percentual_aplicado = accounting.formatNumber(comissao.percentual_aplicado, 2, ".", ",");
                    comissao.data_credito = moment(comissao.data_credito).format('DD/MM/YYYY');
                    comissao.parcela_valor = accounting.formatNumber(comissao.parcela_valor, 2, ".", ",");
                    comissao.valor_recebido = accounting.formatNumber(comissao.valor_recebido, 2, ".", ",");
                    comissao.taxa = accounting.formatNumber(comissao.taxa, 2, ".", ",");
                    return comissao;
                }), ['data_credito'], ['desc'])

                const percentuais_creditado = Object.values(data.creditado.reduce((carry, dados) => {
                    const key = dados.percentual_aplicado;
                    if (carry[key]) {
                        carry[key][`qtde_mov`]++;
                        carry[key][`total_recebido`] += parseFloat(dados.valor_recebido || 0);
                        carry[key][`taxas`] += parseFloat(dados.taxa);
                        carry[key][`total_comissao`] += parseFloat(dados.lancamento_valor);
                    } else {
                        carry[key] = {
                            percentual: parseFloat(dados.percentual_aplicado),
                            qtde_mov: 1,
                            total_recebido: parseFloat(dados.valor_recebido || 0),
                            taxas: parseFloat(dados.taxa),
                            total_comissao: parseFloat(dados.lancamento_valor)
                        };
                    }
                    return carry;
                }, {})).map(perc => {
                    perc.tooltip = perc.taxas ? `${perc.percentual}% (R$ ${ accounting.formatNumber(parseFloat(perc.total_recebido), 2, ".", ",") } - R$ ${ accounting.formatNumber(perc.taxas, 2, ".", ",") })` : null
                    perc.total = accounting.formatNumber(perc.total_comissao, 2, ".", ",");
                    perc.total_recebido = accounting.formatNumber(perc.total_recebido, 2, ".", ",");
                    perc.percentual = accounting.formatNumber(perc.percentual, 2, ".", ",");
                    perc.taxas = accounting.formatNumber(perc.taxas, 2, ".", ",");
                    perc.total_comissao = accounting.formatNumber(perc.total_comissao, 2, ".", ",");
                    return perc;
                })
                const detalhes_creditado = _.orderBy(data.creditado.slice(0).map(comissao => {
                    comissao.tooltip = comissao.taxa ? `${accounting.formatNumber(comissao.percentual_aplicado, 2, ".", ",")}% (R$ ${ accounting.formatNumber(comissao.parcela_valor, 2, ".", ",") } - R$ ${ accounting.formatNumber(comissao.taxa, 2, ".", ",") })` : null
                    comissao.valor = accounting.formatNumber(comissao.lancamento_valor, 2, ".", ",");
                    comissao.percentual_aplicado = accounting.formatNumber(comissao.percentual_aplicado, 2, ".", ",");
                    comissao.data_credito = moment(comissao.data_credito).format('DD/MM/YYYY');
                    comissao.parcela_valor = accounting.formatNumber(comissao.parcela_valor, 2, ".", ",");
                    comissao.valor_recebido = accounting.formatNumber(comissao.valor_recebido, 2, ".", ",");
                    comissao.taxa = accounting.formatNumber(comissao.taxa, 2, ".", ",");
                    return comissao;
                }), ['data_credito'], ['desc'])
                
                this.comissoes.splice(index, 1, {
                    ...this.comissoes[index],
                    percentuais,
                    detalhes,
                    percentuais_em_maos,
                    detalhes_em_maos,
                    percentuais_creditado,
                    detalhes_creditado
                });
               

                setTimeout(() => {
                    this.$refs.comissoes.$children[index].changeHeight();
                }, 100);
                await this.updateStore();
            },
            async updateStore() {
                await this.updateRelatorioComissoes({
                    startDate: this.daterange.startDate,
                    endDate: this.daterange.endDate,
                    idUser: this.idUser,
                    data: [...this.comissoes],
                })
            },
            formatDate(item){
                const mes = item.replace(/\/\d+/,'')
                const ano = item.replace(/\d+\//,'')
                return moment(`${ano}/${mes}`).format('MMM/YYYY')
            },
            computeTotalItem(item){
                let total = 0;
                if (item){
                    item.map(item =>{
                        total+=toDecimal(item.total)
                    })
                }
                return accounting.formatNumber(total, 2, ".", ",")
            }
        },
        created() {
            this.init()
        },
        watch: {
            daterange: {
                handler() {
                    const {startDate, endDate, idUser, data} = this.relatorioComissoes;

                    if (moment(this.daterange.startDate).isSame(startDate, 'day') &&
                        moment(this.daterange.endDate).isSame(endDate, 'day') && this.idUser === idUser && data.length) {
                        this.comissoes = [...data];
                    } else {
                        this.getComissoes();
                    }
                },
                deep: true
            }
        },
    }
</script>
<style lang="stylus">
    .comissoes-bg
        background-color #fff
    .con-expand-users
        .con-btns-user
            display flex
            padding 10px
            padding-bottom 0
            align-items center
            justify-content space-between
            .con-userx
                display flex
                align-items center
                justify-content flex-start
        .list-icon
            i
                font-size .9rem !important
    .comissoes-table
        th
            span.detail
                width 100%
    .th-float * 
        float right
</style>
